import PropTypes from "prop-types";
import React from "react";

/**
 * @param   {Number} width
 * @param   {String} backgroundColor
 * @returns {ReactElement}
 */
export default function ArrowDown({ width, backgroundColor }) {
  return (
    <div
      css={{
        width: 0,
        height: 0,
        borderLeft: `${width} solid transparent`,
        borderRight: `${width} solid transparent`,
        borderTop: `${width} solid ${backgroundColor}`,
      }}
    />
  );
}

ArrowDown.propTypes = {
  width: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};
